module.exports = __webpack_public_path__ + "static/media/renata.4c31a8e5.jpg";